
import { Component, OnInit, ElementRef, ViewChild, Renderer2, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as AOS from 'aos';
import Swiper from 'swiper';
import { Title, Meta } from '@angular/platform-browser';
import { Constants } from '../../common/constants';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ThankYouPopupComponent } from '../../common/thank-you-popup/thank-you-popup.component';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';


@Component({
  selector: 'app-journey-cloud',
  templateUrl: './journey-cloud.component.html',
  styleUrls: ['./journey-cloud.component.css']
})
export class JourneyCloudComponent implements OnInit {
  // journeyToCloudForm: FormGroup;
  isSubmitting = false;
  showPopup = false;
  form!: FormGroup;
  dialogRef!: MatDialogRef<ThankYouPopupComponent>;
  // thankYouVisible: boolean = true;
  baseurl = Constants.baseUrl;
  isBrowser: boolean = false;
  loading = false;

  @ViewChild('pdfLink') pdfLink: any;
  message: any;

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private fb: FormBuilder,
    private http: HttpClient,
    private dialog: MatDialog, @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,

  ) { this.isBrowser=isPlatformBrowser(this.platformId);}

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
      script.type = `application/ld+json`;
      script.text = `
  {
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/journey-to-cloud/"
  },
  "headline": "journey to cloud",
  "description": "Cloud adoption is more than just a technological shift. It’s a strategic advantage for driving business growth and efficiency.",
  "image": "https://mitresource.com/assets/images/homepage/CaseStudies-img-1.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-07-26"
}`;
     
      this._renderer2.appendChild(this._document.head, script);
      this.setTitleAndMetaTags();
    if (this.isBrowser) {
      AOS.init({ disable: 'mobile', duration: 2000, delay: 500, });
      this.handleButtonClick();

    }
    this.form = this.fb.group({
      FirstName: ['', [Validators.required, Validators.minLength(3),Validators.pattern(/^[a-zA-Z]{3,}([ ]?[a-zA-Z]+)*$/)]],
      LastName: ['', [Validators.required,Validators.minLength(3),Validators.pattern(/^[a-zA-Z]{3,}([ ]?[a-zA-Z]+)*$/)]],
      Email: ['', [Validators.required, Validators.email,this.customEmailValidator()]],
      CompanyName: ['', [Validators.required,Validators.minLength(3)]],
      JobTitle: ['', [Validators.required,Validators.minLength(3)]],
      Country: ['', [Validators.required,Validators.minLength(2)]]
    });
  }


  
 

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('journey to cloud | Maganti IT');
    this.metaService.addTags([
      { name: 'description', content: 'Cloud adoption is more than just a technological shift. It’s a strategic advantage for driving business growth and efficiency.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'journey to cloud | Maganti IT' },
      { property: 'og:url', content: 'https://mitresource.com/journey-to-cloud/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/homepage/CaseStudies-imd-1.png' },
      { property: 'og:description', content: 'Cloud adoption is more than just a technological shift. It’s a strategic advantage for driving business growth and efficiency.' },
    ]);
  }
  handleButtonClick() {
    // Get references to the buttons and containers
    const showImagesButton: HTMLElement | null = document.getElementById('showImagesButton');
    const showImages2Button: HTMLElement | null = document.getElementById('showImages2Button');
    const imageContainer1: HTMLElement | null = document.getElementById('image-container1');
    const imageContainer2: HTMLElement | null = document.getElementById('image-container2');

    // Check if any of the elements are null
    if (showImagesButton && showImages2Button && imageContainer1 && imageContainer2) {
      // Add event listener for the first button
      showImagesButton.addEventListener('click', function () {
        // Show the first container and hide the second one
        imageContainer1.style.display = 'block';
        imageContainer2.style.display = 'none';

        // Update button styles
        showImagesButton.classList.add('active-button');
        showImages2Button.classList.remove('active-button');
      });

      // Add event listener for the second button
      showImages2Button.addEventListener('click', function () {
        // Show the second container and hide the first one
        imageContainer1.style.display = 'none';
        imageContainer2.style.display = 'block';

        // Update button styles
        showImages2Button.classList.add('active-button');
        showImagesButton.classList.remove('active-button');
      });

      // Initialize with the first button as active
      showImagesButton.click();
    } else {
      // console.error('One or more elements could not be found in the DOM.');
    }
  }
  onSubmit(): void {
    this.loading = true;
    if (this.form.invalid) {   
      this.form.markAllAsTouched();
      return;
    }
  
    this.isSubmitting = true;
  
    // Perform the form submission logic (e.g., send data to the server)
    const formData = new FormData();
    formData.append('FirstName', this.form.value.FirstName);
    formData.append('LastName', this.form.value.LastName);
    formData.append('Email', this.form.value.Email);
    formData.append('JobTitle', this.form.value.JobTitle);
    formData.append('CompanyName', this.form.value.CompanyName);
    formData.append('Country', this.form.value.Country);

    this.http.post(this.baseurl + '/api/Form/ebookDetails', formData)
      .subscribe(
        (response: any) => {
          this.form.reset(); // Reset the form after successful submission
         
          setTimeout(() => {
            this.isSubmitting = false;
            
            // Download the PDF file only after successful form submission
            this.downloadPDF();
          
            // Open the dialog with the success message
            this.dialogRef = this.dialog.open(ThankYouPopupComponent, {
              data: {
                title: 'Thank You for Your Download!',
                message: 'Check your inbox shortly for the e-book. We hope you find it valuable!'
              }
            });
          
            // Close the dialog after 3 seconds
            setTimeout(() => {
              this.dialogRef.close();
              this.dialog.closeAll();
              this.loading = false; // Hide loader
            }, 3000);
          }, 1000);  // Add a delay (in milliseconds) for the first action, if needed
          
         
        },
        (error: HttpErrorResponse) => {
          // this.message = this.handleError(error);
          // if (error.status === 409) {
          //   const emailControl = this.form.get('Email');
          //   if (emailControl) {
          //     emailControl.setErrors({ interExistedEmail: true });
          //   }
          // }
          this.loading = false;
            // console.error('Error:', error);
          this.isSubmitting = false;
        }
      );
      
  }
  
  handleError(error: any): any {
    throw new Error('Method not implemented.');
  }

  // PDF download function
  downloadPDF(): void {
    if (this.isBrowser) {
      const link = document.createElement('a');
      link.href = '../../../assets/cloud.pdf'; // Path to your PDF file
      link.download = 'cloud.pdf';
      link.click();
    }
  }


// Method to check if a form control is invalid
isFormControlInvalid(controlName: string): boolean {
  const control = this.form.get(controlName);
  return !!(control && control.invalid && control.touched);
}


  // // Utility function to handle form validation
  // isFormControlInvalid(controlName: string): boolean {
  //   const control = this.form.get(controlName);
  //   return control ? control.invalid && (control.dirty || control.touched) : false;
  // }
  getErrorMessage(controlName: string): string {
    const control = this.form.get(controlName);
    if (control?.hasError('required')) {
      if (controlName === "JobTitle") { 
        return `Job title is required.`; 
      }
      if (controlName === "CompanyName") { 
        return `Company Name is required.`; 
      }
      if (controlName === "LastName") { 
        return `Last Name is required.`; 
      }
      if (controlName === "FirstName") { 
        return `First Name is required.`; 
      }
      return `${controlName} is required.`;
    }
    if (control?.hasError('minlength')) {
      const minLength = control.getError('minlength').requiredLength;
      return `${controlName} must be at least ${minLength} characters.`;
    }
    if (control?.hasError('maxlength')) {
      const maxLength = control.getError('maxlength').requiredLength;
      return `${controlName} must be at most ${maxLength} characters.`;
    }
    if (control?.hasError('invalidEmail')) {
      return 'Enter a valid email.';
    }
    //  else if (control?.hasError('interExistedEmail')) {
    //   return 'Email is existing.';}
    //   else if (control?.hasError('maxlength')) {
    //     return 'maximum 50 characters'
    //   }
      else if (control?.hasError('minlength')) {
        return 'Full Name must be at least 2 characters long without spaces';
      }
      else if (control?.hasError('pattern')){
        return 'Enter valid Name'
      }
    return ''; }
  
  
  

  
  // Custom validator for email input
  customEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { emptyEmail: true };
      }
      if (!/^[a-zA-Z][\w\-_.]*[a-zA-Z0-9]@[a-zA-Z]+\.[a-zA-Z]{2,3}$/.test(control.value)) {
        return { invalidEmail: true };
      }
       return null;
    };
  }


  

  customNameValidator(minLength: number, maxLength: number): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value || '';
  
        if (!value) {
          return { emptyName: true };
        }
  
        if (!/^[A-Za-z\s\-'.]+$/.test(value)) {
          return { invalidName: true };
        }
  
        if (value.length < minLength) {
          return { minLength: { requiredLength: minLength, actualLength: value.length } };
        }
        if (value.length > maxLength) {
          return { maxLength: { requiredLength: maxLength, actualLength: value.length } };
        }
  
        return null;
      };
    }
  

  fixedEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // No error if empty
      }
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Adjust this pattern as needed
      return emailPattern.test(control.value) ? null : { invalidEmail: true }; // Invalid if not matching
    };

  }
}
